import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../../../common/GlobalReportPage';
import { GipAltReportPreviewView } from './GipAltReportPreviewView';

type Props = Record<string, never>;

export function GipAlternativeReportPreviewPage(p: Props) {
  const { $t } = useIntl();

  return (
    <BaseGlobalReportPage
      title={$t({
        id: 'audit.globalReports.title',
        defaultMessage: 'Audit global',
      })}
    >
      <GipAltReportPreviewView />
    </BaseGlobalReportPage>
  );
}
